<template>
  <v-row align="start" justif="start" class="ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <v-toolbar height="60" dark color="primary">
        <v-btn fab x-small color="white" depressed @click="onClose()">
          <v-icon class="primary--text">close</v-icon>
        </v-btn>
        <v-toolbar-title class="hidden-xs-only white--text pl-2">生徒一覧</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pa-0 ma-0">
      <v-card tile class="pa-0 ma-0">
        <app-students-list
          :tempGroups="tempGroups"
          :type="type"
          :search="null"
          :selects="selects"
          :group="'*'"
          status=1
          @onSelect="onSelect"
          :contentsHeight="contentsHeight"
        >
        </app-students-list>
      </v-card>
    </v-col>

    <div>
      <v-dialog v-model="studentDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-student-dialog
          v-if="studentDialog"
          @dismissed="onDismissed"
          :dialog='studentDialog'
          :item="item"
          :type="checkPrivileges('edit') ? 'edit' : 'view'"
        >
        </app-student-dialog>
      </v-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>
  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import SList from '../../components/student/List.vue'
Vue.component('app-students-list', SList)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      scholae: 'scholae/scholae',
      students: 'students/students',
      windowSize: 'shared/windowSize'
    }),
    contentsHeight () {
      return 'height: ' + String(this.windowSize.y - 60 - 40 - 4) + 'px;'
    }
  },
  props: [ 'selected', 'tempGroups', 'type' ],
  watch: {
    students () {
      if (this.studentDialog) {
        var index = this.students.findIndex(s => s.key === this.item.key)
        if (index !== -1) {
          this.item = JSON.parse(JSON.stringify(this.students[index]))
        }
      }
    }
  },
  data () {
    return {
      loading: false,
      studentDialog: false,
      item: null,
      selects: {}
    }
  },
  created () {
    for (var i in this.selected) {
      this.selects[this.selected[i].key] = true
    }
  },
  methods: {
    onSelect: function (item) {
      var index = this.students.findIndex(student => student.key === item.key)
      if (index !== -1) {
        this.item = JSON.parse(JSON.stringify(this.students[index]))
        this.studentDialog = true
      }
    },
    onDismissed () {
      this.studentDialog = false
    },
    onClose () {
      this.$emit('dismissed')
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 4px;
}
::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: rgba(0,0,0,.5);
    box-shadow: 0 0 1px rgba(255,255,255,.3);
}
</style>
